import styled from 'styled-components';

import { neutral, primary, white } from '../../../style/colors';

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  text-align: left;
  transition: all 0.2s ease;
  background-color: ${neutral[50]};
  color: ${neutral[700]};
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${neutral[200]};
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: ${white};
    border-color: ${primary[300]};
    color: ${neutral[900]};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &:active {
    background-color: ${neutral[100]};
  }

  &:focus {
    outline: none;
    border-color: ${primary[400]};
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
  }
`;

export default Button;
